export enum TabType {
    ORDERS,
    BALANCE,
    PERSONAL_INFO,
    DELIVERY_ADDRESSES,
    RECIPIENTS,
    NOTIFICATIONS,
    MONTHLY_LIMITS,
    FILES,

    WORKERS,
    INFO,
    COUNTRY,

    STORE,
    PRODUCT_CATEGORY,
    CITY,
    PROVINCE,
    REGION,
    BLOG,
    BLOG_CATEGORY,
    ONLINE_STORES,
    ONLINE_STORE_CATEGORY,

    MESSAGES
}